<div class="modal-backdrop">
  <ng-template #requiredFieldsError>
    <div class="error-text">
      <h3>{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.REQUIRED_FIELDS_NOT_COMPLETED' | translate }}</h3>
      <p>
        {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.PROVIDE_REQUIRED_FIELDS' | translate }}
      </p>
    </div>
  </ng-template>

  <div class="modal-content">
    <!-- HEADER -->
    <div class="popup-header">
      {{ (showActivitySummary ? 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.ACTIVITY_SUMMARY' : 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.ACTIVITY_TRIGGERED') | translate }}
      <ion-buttons slot="end" *ngIf="showActivitySummary">
        <ion-button size="small" fill="clear" (click)="onClose()">
          <ion-icon
            class="close-icon"
            slot="icon-only"
            src="./assets/icon/ic_close.svg"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>

    <!-- BODY SCROLL -->
    <div class="popup-scroll">
      <!-- ACTIVITY SUMMARY MODE -->
      <div *ngIf="showActivitySummary" class="summary-content">
        <div class="summary-list">
          <ion-card *ngFor="let activity of activitySummaryList" class="activity-card clickable-card" (click)="openDetailView(activity)">
            <ion-card-header>
              <ion-card-title class="activity-title">{{ activity.title }}</ion-card-title>
            </ion-card-header>

            <ion-card-content>
              <div class="activity-details">
                <div class="detail-row">
                  <span class="label">S:</span>
                  <span class="value">{{ activity.section }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Q:</span>
                  <span class="value">{{ activity.question }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">A:</span>
                  <span class="value">{{ activity.answer }}</span>
                </div>
              </div>
              <div class="status-action-row">
                <div class="status-badge" [class.completed]="activity.completed">
                  {{ (activity.completed ? 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.REQUIRED_FIELDS_COMPLETED' : 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.REQUIRED_FIELDS_NOT_COMPLETED') | translate }}
                </div>
                <ion-button fill="clear" class="arrow-btn" (click)="openDetailView(activity)">
                  <ion-icon name="chevron-forward" slot="icon-only"></ion-icon>
                </ion-button>
              </div>
            </ion-card-content>
          </ion-card>
        </div>
      </div>

      <div *ngIf="showSignoffError" class="signoff-error-content">
        <div class="error-message-container">
          <ng-container *ngTemplateOutlet="requiredFieldsError"></ng-container>
        </div>
      </div>

      <!-- ACTIVITY DETAILS MODE -->
      <div *ngIf="!showActivitySummary && !showSignoffError">
        <!-- ERROR STATE -->
        <div class="error-message-container" [hidden]="!showRequiredFieldsError">
          <ng-container *ngTemplateOutlet="requiredFieldsError"></ng-container>
        </div>

        <!-- POPUP BODY (HIDDEN IF ERROR) -->
        <div class="popup-body" [hidden]="showRequiredFieldsError">
          <div class="label-title">{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.SECTION' | translate }}</div>
          <div class="label-value">{{ activityPopupData?.sectionName }}</div>

          <div class="label-title">{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.QUESTION' | translate }}</div>
          <div class="label-value">{{ activityPopupData?.questionText }}</div>

          <div class="label-title">{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.ANSWER_SELECTED' | translate }}</div>
          <div class="label-value">{{ activityPopupData?.answerText }}</div>

          <!-- ACTIVITY TYPE -->
          <app-dropdown-field
            [form]="formGroup"
            [label]="'Activity Type'"
            [inputName]="'activityType'"
            [list]="activityTypeOptions"
            [listLabelKey]="'label'"
            [listValueKey]="'value'"
            [isError]="false"
            [placeholder]="'Select an option'"
            [preValue]="activityPopupData?.questionLogic?.activityType"
            [disabled]="true"
            (valueChange)="onActivityTypeChange($event)"
          ></app-dropdown-field>

          <!-- ACTIVITY FROM (SIGNOFF) -->
          <app-singleline-text-field
            *ngIf="
              activityPopupData?.questionLogic?.activityType === EnumService.ActivityType.FORM_SIGNOFF_ACTIVITY ||
              activityPopupData?.questionLogic?.activityType === EnumService.ActivityType.DOCUMENT_SIGNOFF_ACTIVITY
            "
            [label]="'Activity From'"
            [form]="formGroup"
            [inputName]="'activityFormDisplay'"
            [preValue]="activityPopupData?.questionLogic?.activityAssignedFormName || 'No form assigned'"
            [disabled]="true"
          ></app-singleline-text-field>

          <!-- ACTIVITY TITLE -->
          <app-singleline-text-field
            [form]="formGroup"
            [label]="'Activity Title'"
            [inputName]="'activityTitle'"
            [preValue]="(this.activityPopupData?.questionLogic?.isActTitlePredefined === true || this.activityPopupData?.questionLogic?.isActTitlePredefined === null) ? activityPopupData?.questionLogic?.activityTitle : ''"
            [disabled]="activityPopupData?.questionLogic?.isActTitlePredefined === true || activityPopupData?.questionLogic?.isActTitlePredefined === null"
            [requiredField]="activityPopupData?.questionLogic?.isActTitlePredefined === false"
          ></app-singleline-text-field>

          <!-- ACTIVITY DESCRIPTION -->
          <app-multiline-text-field
            [label]="'Activity Description'"
            [form]="formGroup"
            [inputName]="'activityDescription'"
            [preValue]="(activityPopupData?.questionLogic?.isDescriptionPredefined === true || activityPopupData?.questionLogic?.isDescriptionPredefined === null) ? activityPopupData?.questionLogic?.activityDescription : ''"
            [disabled]="activityPopupData?.questionLogic?.isDescriptionPredefined === true || activityPopupData?.questionLogic?.isDescriptionPredefined === null"
          ></app-multiline-text-field>

          <!-- ACTIVITY EXPLANATION -->
          <app-multiline-text-field
            [label]="'Activity Explanation'"
            [form]="formGroup"
            [inputName]="'activityExplanation'"
            [preValue]="(activityPopupData?.questionLogic?.isExplanationPredefined === true || activityPopupData?.questionLogic?.isExplanationPredefined === null) ? activityPopupData?.questionLogic?.activityExplanation : ''"
            [disabled]="activityPopupData?.questionLogic?.isExplanationPredefined === true || activityPopupData?.questionLogic?.isExplanationPredefined === null"
          ></app-multiline-text-field>

          <!-- OWNER -->
          <app-user-selector
            [label]="'Owner'"
            [placeholder]="'Search owner'"
            [users]="filteredUserList"
            [selectedUsers]="selectedOwner"
            [selectionMode]="'single'"
            (usersSelected)="onOwnerSelected($event)"
            [isPredefined]="activityPopupData?.questionLogic?.isOwnerPredefined === true || activityPopupData?.questionLogic?.isOwnerPredefined === null">
          </app-user-selector>

          <!-- ASSIGNEES -->
          <app-user-selector
            [label]="'Assignee'"
            [placeholder]="'Search assignee'"
            [users]="filteredUserList"
            [selectedUsers]="selectedAssignees"
            (usersSelected)="onAssigneesSelected($event)"
            [isPredefined]="activityPopupData?.questionLogic?.isAssigneePredefined === true || activityPopupData?.questionLogic?.isAssigneePredefined === null">
          </app-user-selector>

          <!-- DUE DATE / EXPIRY -->
          <div class="date-container">
            <ion-label position="stacked">{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.DUE_DATE' | translate }}<app-required-asterisk [show]="activityPopupData?.questionLogic?.isDatePredefined === false" /></ion-label>
            <div class="expiration-date-view">
              <app-date-field
                *ngIf="activityPopupData?.questionLogic?.isDatePredefined === false"
                [form]="formGroup"
                [label]="'Due Date'"
                inputName="dueDate"
                [isError]="false"
                [placeholder]="'Select due date'"
                [uniqueId]="'activityDueDate'"
                [preValue]="getActivityDueDate()"
                [isPlaceholderEnabled]="true"
                (dateChanged)="onDueDateChanged($event)">
              </app-date-field>
              <div *ngIf="activityPopupData?.questionLogic?.isDatePredefined === true || activityPopupData?.questionLogic?.isDatePredefined === null" class="expireduration-field">
                <ion-input
                  inputmode="numeric"
                  formControlName="expireAfterDuration"
                  (ionChange)="updateActivityDuration($event)"
                  [value]="formGroup.get('expireAfterDuration').value"
                  [disabled]="activityPopupData?.questionLogic?.isDatePredefined === true || activityPopupData?.questionLogic?.isDatePredefined === null">
                </ion-input>
                <app-dropdown-field
                  listLabelKey="title"
                  listValueKey="id"
                  interface="popover"
                  [form]="formGroup"
                  [placeholder]="'Choose'"
                  inputName="expireAfterDurationType"
                  [list]="expireDurationTypes"
                  [isError]="false"
                  (ionChange)="updateActivityDurationType()"
                  [preValue]="formGroup.get('expireAfterDurationType').value"
                  [disabled]="activityPopupData?.questionLogic?.isDatePredefined === true || activityPopupData?.questionLogic?.isDatePredefined === null">
                </app-dropdown-field>
              </div>
            </div>
          </div>

          <!-- HIGH PRIORITY CHECKBOX -->
          <div class="priority-checkbox-container">
            <ion-item lines="none">
              <ion-label>{{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.HIGH_PRIORITY' | translate }}</ion-label>
              <ion-checkbox
                slot="start"
                [formControl]="formGroup.get('isHighPriorityActivity')"
                aria-label="isHighPriorityActivity">
              </ion-checkbox>
            </ion-item>
          </div>
        </div>

        <!-- SAVE & RETURN BUTTONS -->
        <!-- <ng-container *ngIf="!showRequiredFieldsError">
          <div class="required-status" [ngClass]="{ 'defined': !isRequiredFieldsEmpty(), 'not-defined': isRequiredFieldsEmpty() }">
            {{ isRequiredFieldsEmpty() ? 'Required fields not completed' : 'Required fields are completed' }}
          </div>
          <div class="error-actions">
            <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onDeselect()">
              Deselect
            </ion-button>
            <ion-button expand="full" class="action-btn" (click)="onSave()">
              Save
            </ion-button>
          </div>
        </ng-container> -->

        <!-- ERROR MODE BUTTONS -->
        <!-- <ng-container *ngIf="showRequiredFieldsError">
          <div class="error-actions">
            <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onBackFromError()">
              Return
            </ion-button>
            <ion-button expand="block" class="action-btn continue-btn" (click)="onSave(true)">
              Continue
            </ion-button>
          </div>
        </ng-container> -->
      </div>

      <!-- SIGNOFF ERROR -->
      <!-- <div *ngIf="showSignoffError" class="signoff-error-content">
        <div class="error-message-container">
          <ng-container *ngTemplateOutlet="requiredFieldsError"></ng-container>
        </div>
        <div class="error-actions">
          <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onClose()">
            Return to Form
          </ion-button>
          <ion-button expand="block" class="action-btn continue-btn" (click)="activitySummaryClick.emit()">
            Open Summary
          </ion-button>
        </div>
      </div> -->
    </div>
    <div class="popup-footer">
      <!-- SAVE & RETURN BUTTONS -->
      <ng-container *ngIf="!showActivitySummary && !showSignoffError && !showRequiredFieldsError">
        <div class="required-status" [ngClass]="{ 'defined': !isRequiredFieldsEmpty(), 'not-defined': isRequiredFieldsEmpty() }">
          {{ (isRequiredFieldsEmpty() ? 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.REQUIRED_FIELDS_NOT_COMPLETED' : 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.REQUIRED_FIELDS_ARE_COMPLETED') | translate }}
        </div>
        <div class="error-actions">
          <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onDeselect()">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.DESELECT' | translate }}
          </ion-button>
          <ion-button expand="full" class="action-btn" (click)="onSave()">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.SAVE' | translate }}
          </ion-button>
        </div>
      </ng-container>

      <!-- ERROR MODE BUTTONS -->
      <ng-container *ngIf="!showActivitySummary && !showSignoffError && showRequiredFieldsError">
        <div class="error-actions">
          <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onBackFromError()">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.RETURN' | translate }}
          </ion-button>
          <ion-button expand="block" class="action-btn continue-btn" (click)="onSave(true)">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.CONTINUE' | translate }}
          </ion-button>
        </div>
      </ng-container>

      <!-- SIGNOFF ERROR BUTTONS -->
      <ng-container *ngIf="showSignoffError">
        <div class="error-actions">
          <ion-button expand="block" fill="outline" class="action-btn return-btn" (click)="onClose()">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.RETURN_TO_FORM' | translate }}
          </ion-button>
          <ion-button expand="block" class="action-btn continue-btn" (click)="activitySummaryClick.emit()">
            {{ 'PAGESPECIFIC_TEXT.ACTIVITY_CREATION.OPEN_SUMMARY' | translate }}
          </ion-button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
